"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InnerSelect = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APSelect.css");
var _excluded = ["input", "meta", "classModifiers", "customClass", "info", "label", "onSelect", "showTriangles", "options"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var InnerSelect = exports.InnerSelect = function InnerSelect(props) {
  var input = props.input,
    meta = props.meta,
    classModifiers = props.classModifiers,
    customClass = props.customClass,
    info = props.info,
    label = props.label,
    onSelect = props.onSelect,
    showTriangles = props.showTriangles,
    options = props.options,
    passedProps = _objectWithoutProperties(props, _excluded);
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)(['ap-select', customClass]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(baseClasses('select-wrapper', classModifiers))
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "ap--label ".concat(baseClasses('select-label'))
  }, label), showTriangles ? /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('triangles-container')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'triangle-up'
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'triangle-down'
  })) : '', /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: "form-control ".concat(baseClasses('select'))
  }, input, passedProps, {
    onChange: function onChange(e) {
      if (onSelect) onSelect(e.target.value);
      input && input.onChange(e);
    }
  }), options.map(function (i, idx) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: "".concat(idx, "-").concat(i.value),
      value: i.value,
      disabled: i.disabled,
      selected: i.selected
    }, i.label);
  })), /*#__PURE__*/_react["default"].createElement("small", {
    className: "form-text-muted ".concat(baseClasses('select-info'))
  }, info), meta && meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('select-error')
  }, meta.error));
};
var APSelect = function APSelect(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: InnerSelect
  }, props));
};
APSelect.defaultProps = {
  name: '',
  label: '',
  classes: 'input',
  customClass: 'custom-select',
  classModifiers: '',
  info: '',
  autoFocus: '',
  disabled: false,
  multiple: false,
  required: false,
  options: []
};
APSelect.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  classes: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].string,
  info: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].node]),
  autoFocus: _propTypes["default"].string,
  onSelect: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  required: _propTypes["default"].bool
};
var _default = exports["default"] = APSelect;